module.exports = __webpack_public_path__ + "static/media/buggy_park.036796ee.svg";